<div class="container-appointment" *ngIf="completed">
  <div class="logo brand{{model.brandId}}french" *ngIf="french"></div>
  <div class="logo brand{{model.brandId}}" *ngIf="!french"></div>
  <div class="row">
    <div class="col-lg-12 appointment-with-page-header-title brand{{model.brandId}}">
      <span *ngIf="!french">
        <ng-container *ngIf="contact && contact.firstname">Hi {{contact.firstname}}, w</ng-container>
        <ng-container *ngIf="!contact || !contact.firstname">W</ng-container>elcome to {{model.brandName}} booking portal.
      </span>
      <span *ngIf="french">Bienvenue au portail de prise de rendez-vous du {{model.brandName}}.</span>
    </div>
  </div>
  <div class="row">
    <div class="col-lg-12 appointment-with-page-title brand{{model.brandId}}">
      <span>{{ 'STEP' | translate }} 1</span>
      <svg *ngIf="model.brandId != 543" width="6" height="6" viewBox="0 0 6 6" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="3" cy="3" r="3" fill="#303030" />
      </svg>
      <svg *ngIf="model.brandId == 543" xmlns="http://www.w3.org/2000/svg" width="6" height="7" viewBox="0 0 6 7" fill="none">
        <path d="M3 6.09009C4.65685 6.09009 6 4.74694 6 3.09009C6 1.43323 4.65685 0.0900879 3 0.0900879C1.34315 0.0900879 0 1.43323 0 3.09009C0 4.74694 1.34315 6.09009 3 6.09009Z" fill="white" />
      </svg>
      <p>{{bookingTitle}}</p>
    </div>
  </div>
  <div class="row">
    <div class="col-lg-7 appointment-with-wrapper">
      <div class="panel-wrapper process-wrapper">
        <div class="process" *ngIf="loading"><div class="brand{{model.brandId}}"></div></div>
        <div class="panel-body box-bg-color-{{model.brandId}} appointment-with-panel-wrapper">
          <div class="appointment-with-panel-body">
            <ng-container *ngIf="step == 1">
              <div class="appointment-with-subtitle brand{{model.brandId}}">
                {{apptWithSubtitle}}
              </div>
              <div class="appointment-with-email">
                <div class="input-button-inline brand{{model.brandId}}">
                  <input type="email" [placeholder]="'ENTER_EMAIL' | translate" [(ngModel)]="model.email" name="email" (keyup.enter)="getCalendar()" />
                  <button type="button" class="btn btn-primary brand{{model.brandId}}" (click)="getCalendar();" [disabled]="inviteInvalid()">{{ 'CONFIRM_EMAIL' | translate }}</button>
                </div>
              </div>
              <div style="margin-top:-15px ; margin-right:-15px" class="appointment-with-form-title brand{{model.brandId}} error-color" *ngIf="!hasShift">
                {{ 'APPT_CANT_BE_BOOKED' | translate }}
              </div>
            </ng-container>
            <ng-container *ngIf="step == 2">
              <div class="appointment-with-back brand{{model.brandId}}">
                <div (click)="cancelInfoForm();">
                  &larr;
                  <span>{{ 'BACK' | translate }}</span>
                </div>
              </div>
              <div class="appointment-with-form-title brand{{model.brandId}} error-color">
                <span>{{ 'NO_EMAIL_FOUND' | translate }}</span>
              </div>
              <div class="appointment-with-form-wrapper">
                <div class="row">
                  <div class="col-md-6">
                    <div class="appointment-with-form-label brand{{model.brandId}}">
                      <span>{{ 'FIRST_NAME' | translate }}</span>
                    </div>
                    <div class="appointment-with-form-input">
                      <input class="form-control brand{{model.brandId}}" type="text" [placeholder]="'FIRST_NAME' | translate" [(ngModel)]="contact.firstname" name="firstname"  />
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="appointment-with-form-label brand{{model.brandId}}">
                      {{ 'LAST_NAME' | translate }}
                    </div>
                    <div class="appointment-with-form-input">
                      <input class="form-control brand{{model.brandId}}" type="text" [placeholder]="'LAST_NAME' | translate" [(ngModel)]="contact.lastname" name="lastname"
                             />
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-6">
                    <div class="appointment-with-form-label brand{{model.brandId}}">
                      {{ 'EMAIL' | translate }}
                    </div>
                    <div class="appointment-with-form-input">
                      <input class="form-control brand{{model.brandId}}" type="text" [placeholder]="'EMAIL' | translate" [(ngModel)]="contact.email" name="contactemail" />
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="appointment-with-form-label brand{{model.brandId}}">
                      {{ 'PHONE' | translate }}
                    </div>
                    <div class="appointment-with-form-input">
                      <input class="form-control brand{{model.brandId}}" type="text" [placeholder]="'PHONE' | translate" [(ngModel)]="contact.phone" name="phone"/>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-6">
                    <div class="appointment-with-form-label brand{{model.brandId}}">
                      {{ 'POSTAL_CODE' | translate }}
                    </div>
                    <div class="appointment-with-form-input">
                      <input class="form-control brand{{model.brandId}}" type="text" [placeholder]="'POSTAL_CODE' | translate" [(ngModel)]="contact.postcode" name="postcode"/>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="appointment-with-form-label brand{{model.brandId}}">
                      {{ 'SELECT_PROGRAM' | translate }}
                    </div>
                    <div class="appointment-with-form-select select-box">
                      <select class="form-control brand{{model.brandId}}" id="program"
                              required
                              [(ngModel)]="contact.program" name="program"
                              [disabled]="false"
                              #program="ngModel">
                        <option [ngValue]="0" [disabled]="true">{{'SELECT_PROGRAM_PLACEHOLDER' | translate}}</option>
                        <optgroup *ngFor="let category of categories" label="{{category.categoryName}}">
                          <option *ngFor="let item of category.items" [ngValue]="item.id">{{item.name}}</option>
                        </optgroup>
                      </select>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-6">
                    <input type="button" class="btn btn-primary brand{{model.brandId}}" style="border-radius:4px;" [value]="'SUBMIT' | translate" [disabled]="formInvalid() || submitting" (click)="submitInfoForm();" />
                    <div class="appointment-with-form-title brand{{model.brandId}} error-color">{{ errorSourceId }}</div>
                    <div *ngIf="submissionError" class="appointment-with-form-title brand{{model.brandId}} error-color" role="alert">{{ submissionError }}</div>
                  </div>
                </div>
              </div>
            </ng-container>
            <ng-container *ngIf="step == 3">
              <div class="appointment-with-subtitle">
                {{ 'PROVIDE_EMAIL' | translate }}
              </div>
              <div class="appointment-with-email">
                <div class="input-button-inline brand{{model.brandId}}">
                  <input type="email" [placeholder]="'ENTER_EMAIL' | translate" [(ngModel)]="model.email" name="email" (keyup.enter)="getCalendar()"/>
                  <button type="button" class="btn btn-primary brand{{model.brandId}}" (click)="getCalendar();" [disabled]="inviteInvalid()">{{ 'CONFIRM_EMAIL' | translate }}</button>
                </div>
              </div>
              <div style="margin-top:-15px ; margin-right:-15px" class="appointment-with-form-title brand{{model.brandId}} error-color">
                {{ 'APPT_NOT_BOOKABLE' | translate }}
              </div>
            </ng-container>
          </div>
        </div>
      </div>
    </div>
    <div class="col-lg-5 appointment-date-wrapper">
      <div class="panel-wrapper faded brand{{model.brandId}}">
        <div class="panel-header appointment-date-header brand{{model.brandId}}">
          <div class="appointment-date-title brand{{model.brandId}}">
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M3.5 0C3.63261 0 3.75979 0.0526784 3.85355 0.146447C3.94732 0.240215 4 0.367392 4 0.5V1H12V0.5C12 0.367392 12.0527 0.240215 12.1464 0.146447C12.2402 0.0526784 12.3674 0 12.5 0C12.6326 0 12.7598 0.0526784 12.8536 0.146447C12.9473 0.240215 13 0.367392 13 0.5V1H14C14.5304 1 15.0391 1.21071 15.4142 1.58579C15.7893 1.96086 16 2.46957 16 3V14C16 14.5304 15.7893 15.0391 15.4142 15.4142C15.0391 15.7893 14.5304 16 14 16H2C1.46957 16 0.960859 15.7893 0.585786 15.4142C0.210714 15.0391 0 14.5304 0 14V5H16V4H0V3C0 2.46957 0.210714 1.96086 0.585786 1.58579C0.960859 1.21071 1.46957 1 2 1H3V0.5C3 0.367392 3.05268 0.240215 3.14645 0.146447C3.24021 0.0526784 3.36739 0 3.5 0V0Z" fill="white" />
            </svg>
            <p>{{ 'SELECT_DATE' | translate }}</p>
          </div>
        </div>
        <div class="panel-body box-bg-color-{{model.brandId}} appointment-date-body">
          <div class="appointment-date-month brand{{model.brandId}}">
            {{model.month}}
          </div>
          <div class="appointment-date-day-wrapper">
            <div class="appointment-date-day brand{{model.brandId}} disabled" *ngFor="let day of model.days" [ngClass]="{'selected': day.selected}">
              <p class="appointment-date-day-title">{{day.date}}</p>
              <p class="appointment-date-day-number">{{day.day}}</p>
            </div>
          </div>
          <div class="appointment-date-select">
            <div class="appointment-date-select-title brand{{model.brandId}}">
              {{ 'SELECT_TIMEZONE' | translate }}
            </div>
            <div class="appointment-date-select-select select-box">
              <select class="form-control brand{{model.brandId}}" id="timeZone" required disabled="disabled" name="timeZone">
                <option>{{ 'SELECT_TIMEZONE_PLACEHOLDER' | translate }}</option>
              </select>
            </div>
          </div>
          <div class="appointment-date-select appointment-date-select-below">
            <div class="appointment-date-select-title brand{{model.brandId}}">
              {{ 'SELECT_TIME' | translate }}
            </div>
            <div class="appointment-date-select-select select-box">
              <select class="form-control brand{{model.brandId}}" id="time" required disabled="disabled" name="time">
                <option>{{ 'SELECT_TIME_PLACEHOLDER' | translate }}</option>
              </select>
            </div>
          </div>
          <div class="appointment-date-select appointment-date-select-below">
            <div class="appointment-date-select-title brand{{model.brandId}}">
              {{ 'SELECT_CONNECTION' | translate }}
            </div>
            <div class="appointment-date-select-select select-box">
              <select class="form-control brand{{model.brandId}}" id="meet" required disabled="disabled" name="meet">
                <option>{{ 'SELECT_CONNECTION_PLACEHOLDER' | translate }}</option>
              </select>
            </div>
          </div>
          <input type="button" class="btn btn-primary brand{{model.brandId}} faded" [value]="'BOOK_APPOINTMENT' | translate" disabled="disabled" />
        </div>
      </div>
    </div>
  </div>
  <app-testimonial [brand]="model.brand" [french]="french" [events]="brandSubject.asObservable()" [hidden]="!model.brand"></app-testimonial>
</div>
